import { DEFAULT_GENERATION } from '../constants'

export const initialGenerationState = {
  generation: { ...DEFAULT_GENERATION },
}
